import { useHealthdex } from "@/hooks/use-healthdex";
import { feature, features } from "@/utils/feature-verifier";

/**
 * Single gate for every HCI (Healthcare Institution) UI surface.
 *
 * HCI is both healthdex-only *and* behind the HCI_IMPROVEMENT rollout flag,
 * which mirrors the admin-corev2 env constant of the same name. Callers must
 * use this hook rather than composing `useHealthdex()` with `feature()`
 * themselves, so the two conditions cannot drift apart between surfaces.
 *
 * `feature()` is build-time (REACT_APP_CDI_ENV), so this also works on the
 * public, pre-auth signup page where the redux `useFeature()` hook cannot.
 */
export const useHciImprovement = () => {
	const isHealthdex = useHealthdex();

	return isHealthdex && feature(features.HCI_IMPROVEMENT);
};
